import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalDelivery: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">LotusRecruiter</Link>
          <Link to="/login" className="text-sm text-lotus-gold font-semibold">
            {t('legal.customerLogin')}
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-md p-8 space-y-8">
          <div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold">{t('legal.delivery.label')}</p>
            <h1 className="text-3xl font-bold text-gray-900 mt-2">{t('legal.delivery.title')}</h1>
            <p className="mt-4 text-gray-600 leading-relaxed">
              {t('legal.delivery.intro')}
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.delivery.refundTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.delivery.refund')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.delivery.supportTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.delivery.support')}
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default LegalDelivery;
